import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { ClaimWeldErrorProps } from './types';
import { ClaimWeldError, ClaimApproveWeldError } from '@bechtel/types';

const getErrorMessage = (error: ClaimWeldErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case ClaimWeldError.CLAIM_WELD_MILESTONE_ERRORED:
      return <Trans>Claim weld errored.</Trans>;
    case ClaimWeldError.EIS_ERROR:
      return <Trans>EIS error.</Trans>;
    case ClaimWeldError.MILESTONE_CONFIG_NOT_FOUND:
      return <Trans>Milestone config not found.</Trans>;
    case ClaimWeldError.MILESTONE_IS_ALREADY_CLAIMED:
      return <Trans>Weld is already claimed.</Trans>;
    case ClaimWeldError.MILESTONE_IS_APPROVED:
      return <Trans>Weld is approved.</Trans>;
    case ClaimWeldError.MILESTONE_IS_BLOCKED:
      return <Trans>Weld is blocked.</Trans>;
    case ClaimWeldError.MILESTONE_IS_REJECTED:
      return <Trans>Weld is rejected.</Trans>;
    case ClaimWeldError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case ClaimWeldError.NOT_FOUND:
      return <Trans>Not Found.</Trans>;
    case ClaimWeldError.INVALID_STENCILS:
      return <Trans>Invalid Stencils.</Trans>;
    case ClaimWeldError.SERVICE_PROXY_ERROR:
      return <Trans>Server proxy error.</Trans>;
    case ClaimWeldError.STENCILS_NOT_PROVIDED:
      return <Trans>Stencils not selected.</Trans>;
    case ClaimWeldError.WELD_PROCEDURE_NOT_FROM_APPLICABLE_LIST:
      return <Trans>Weld procedure not from applicable list.</Trans>;
    case ClaimApproveWeldError.CLAIM_APPROVE_WELD_MILESTONE_ERRORED:
      return <Trans>Claim And approve weld errored.</Trans>;
    case ClaimWeldError.PREVIOUS_MILESTONE_NOT_CLAIMED_YET:
      return <Trans>This weld cannot be claimed since the fitup milestone has not been claimed yet. Please press the
      &ldquo;Update&rdquo; button to fetch the latest data and try again.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const ClaimWeldErrorModal: FC<ClaimWeldErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Claim Weld Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
